import React from 'react';
import '../../pages/carritoCompra/carritoCompra.css';
import {CardCarritoCompra} from './CardCarritoCompra';
import {useSessionStore} from '../../hooks/useSessionStore';

export const ContentCarritoCompra = () => {
	/* A hook that allows you to store data in the session. */
	const [Usuario, setUsuario] = useSessionStore({Usuario: 'Usuario'});

	/* A function that allows you to change the value of the start of care. */
	const onChangeComienzoCuidados = (value, product) => {
		let listaAxu = [];
		Usuario.listaCarrito.map((item) => {
			if (item.empresa === product.empresa && item.nombre === product.nombre) {
				item.comienzoCuidados = value;
			}
			listaAxu.push(item);
		});
		setUsuario({
			...Usuario,
			listaCarrito: listaAxu,
		});
	};

	/**
	 * It takes a value and a product, then it creates a new list, then it maps through the list of items
	 * in the cart, then it checks if the item is the same as the product, then it changes the duration
	 * of the item, then it pushes the item to the new list, then it sets the user's cart to the new list
	 */
	const onChangeHorasSemana = (value, product) => {
		let listaAxu = [];
		Usuario.listaCarrito.map((item) => {
			if (item.empresa === product.empresa && item.nombre === product.nombre) {
				item.duracion = value;
			}
			listaAxu.push(item);
		});
		setUsuario({
			...Usuario,
			listaCarrito: listaAxu,
		});
	};

	/* A function that takes a product, then it creates a new list, then it maps through the list of
  items in the cart, then it checks if the item is the same as the product, then it pushes the item
  to the new list, then it sets the user's cart to the new list. */
	const borrarProducto = (product) => {
		let listaAxu = [];
		Usuario.listaCarrito.map((item) => {
			if (item.nombre !== product.nombre || item.empresa !== product.empresa) {
				listaAxu.push(item);
			}
		});
		setUsuario({
			...Usuario,
			listaCarrito: listaAxu,
		});
	};

	/* Returning a JSX element. */
	return (
		<>
			<div className='centrador1fr'>
				<div className='centrador tituloCarrito'>
					<b>Cesta</b>
				</div>
				{Usuario.listaCarrito.length > 0 && <div className='separadorCarrito'></div>}
				{Usuario.listaCarrito.map((producto, key) => (
					<>
						<div className='contentCardExterior'>
							<CardCarritoCompra
								key={key}
								producto={producto}
								onChangeComienzoCuidados={onChangeComienzoCuidados}
								onChangeHorasSemana={onChangeHorasSemana}
								borrarProducto={borrarProducto}
							/>
						</div>
						<div className='separadorCarrito'></div>
					</>
				))}
			</div>
			<div className='contentBotonIferiorCarritoCompra'>
				{Usuario.listaCarrito.length > 0 ? (
					<div
						Id='buttonCarritoCompra'
						className='centrador'
					>
						<div>
							<b>Continuar</b>
						</div>
					</div>
				) : (
					<div
						Id='buttonCarritoCompra'
						className='centrador'
					>
						<div>
							<b>Salir</b>
						</div>
					</div>
				)}
			</div>
		</>
	);
};
